module.exports = __webpack_public_path__ + "img/AZ.e9980524.png";